var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loaded)?_c('div',{key:"1",staticClass:"loading",class:("loading-" + (_vm.size || 'sm') + " " + _vm.color)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }